import React from "react";
import practice_img_1 from "../../assets/images/practice-img-1.jpg";
import practice_img_2 from "../../assets/images/practice-img-2.jpg";
import practice_img_3 from "../../assets/images/practice-img-3.jpg";
import practice_img_4 from "../../assets/images/practice-img-4.jpg";
import practice_img_5 from "../../assets/images/practice-img-5.jpg";
import practice_img_6 from "../../assets/images/practice-img-6.jpg";
import StarBorderOutlinedIcon from "@mui/icons-material/StarBorderOutlined";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
const HomePagePractice = () => {
  return (
    <div className="w-full flex justify-center items-center pt-[60px] overflow-hidden mt-20 pb-[120px] relative">
           <div
        className="absolute -bottom-1 rotate-180 w-full mt-8 "
        data-negative="false"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1000 100"
          preserveAspectRatio="none"
          className="h-[150px] -z-10 block relative left-1/2 transform -translate-x-1/2"
          style={{
            width: "calc(198% + 1.3px)",
          }}
        >
          <path
            opacity="0.66"
            fill="#D6ECE1"
            d="M734,67.3c-45.5,0-77.2-23.2-129.1-39.1c-28.6-8.7-150.3-10.1-254,39.1 s-91.7-34.4-149.2,0C115.7,118.3,0,39.8,0,39.8V0h1000v36.5c0,0-28.2-18.5-92.1-18.5C810.2,18.1,775.7,67.3,734,67.3z"
          ></path>
          <path
            fill="#D6ECE1"
            d="M766.1,28.9c-200-57.5-266,65.5-395.1,19.5C242,1.8,242,5.4,184.8,20.6C128,35.8,132.3,44.9,89.9,52.5C28.6,63.7,0,0,0,0 h1000c0,0-9.9,40.9-83.6,48.1S829.6,47,766.1,28.9z"
          ></path>
        </svg>{" "}
      </div>
      <div className="xl:w-[75%] w-[90%] flex  flex-col gap-3 mb-14 justify-center ">
        <div className=" text-[#CFA649] font-playfair text-2xl font-medium">
          {" "}
          Practice{" "}
        </div>
        <h3 className="text-[35px] leading-[54px] capitalize font-semibold text-[#17543e] font-playfair">
          Home and On-the-go classes{" "}
        </h3>
        <div className="w-full flex flex-col mb-4 md:flex-row">
          <div className="md:w-1/3  w-full  p-4">
            <div className="flex flex-col w-full border-[1px]">
              <div className="w-full ">
                <img
                  src={practice_img_1}
                  alt="practice_img_1"
                  className="object-cover"
                />
              </div>
              <div className="p-6 border-b-[1px]">
                <p className="flex flex-row gap-1 mb-2">
                  <StarBorderOutlinedIcon className="text-[#cfa649]" />
                  <StarBorderOutlinedIcon className="text-[#cfa649]" />
                  <StarBorderOutlinedIcon className="text-[#cfa649]" />
                  <StarBorderOutlinedIcon className="text-[#cfa649]" />
                  <StarBorderOutlinedIcon className="text-[#cfa649]" />
                </p>
                <h3 className="text-2xl font-playfair text-[#17543e] font-medium">
                  <a href="inhale-namaste-mudra-bandha">
                    {" "}
                    Breath of fire inhale
                  </a>
                </h3>
              </div>
              <div className="flex justify-between gap-3 lg:gap-0 px-4 md:px-1 lg:px-4 py-3 items-center">
                <p className="text-[17px] text-[#cfa649] font-playfair font-bold">
                  Free
                </p>
                <a href="/" className="text-[17px]  font-bold text-[#16563f]">
                  <WidgetsOutlinedIcon /> Get Enrolled
                </a>
              </div>
            </div>
          </div>
          <div className="md:w-1/3  w-full   p-4">
            <div className="flex flex-col w-full border-[1px]">
              <div className="w-full ">
                <img
                  src={practice_img_5}
                  alt="practice_img_1"
                  className="object-cover"
                />
              </div>
              <div className="p-6 border-b-[1px]">
                <p className="flex flex-row gap-1 mb-2">
                  <StarBorderOutlinedIcon className="text-[#cfa649]" />
                  <StarBorderOutlinedIcon className="text-[#cfa649]" />
                  <StarBorderOutlinedIcon className="text-[#cfa649]" />
                  <StarBorderOutlinedIcon className="text-[#cfa649]" />
                  <StarBorderOutlinedIcon className="text-[#cfa649]" />
                </p>
                <h3 className="text-2xl font-playfair text-[#17543e] font-medium">
                  <a href="inhale-namaste-mudra-bandha">
                    {" "}
                    Breath of fire inhale
                  </a>
                </h3>
              </div>
              <div className="flex justify-between gap-3 lg:gap-0 px-4 md:px-1 lg:px-4 py-3 items-center">
                <p className="text-[17px] text-[#cfa649] font-playfair font-bold">
                  Free
                </p>
                <a href="/" className="text-[17px]  font-bold text-[#16563f]">
                  <WidgetsOutlinedIcon /> Get Enrolled
                </a>
              </div>
            </div>
          </div>
          <div className="md:w-1/3  w-full  p-4">
            <div className="flex flex-col w-full border-[1px]">
              <div className="w-full ">
                <img
                  src={practice_img_4}
                  alt="practice_img_1"
                  className="object-cover"
                />
              </div>
              <div className="p-6 border-b-[1px]">
                <p className="flex flex-row gap-1 mb-2">
                  <StarBorderOutlinedIcon className="text-[#cfa649]" />
                  <StarBorderOutlinedIcon className="text-[#cfa649]" />
                  <StarBorderOutlinedIcon className="text-[#cfa649]" />
                  <StarBorderOutlinedIcon className="text-[#cfa649]" />
                  <StarBorderOutlinedIcon className="text-[#cfa649]" />
                </p>
                <h3 className="text-2xl font-playfair text-[#17543e] font-medium">
                  <a href="inhale-namaste-mudra-bandha"> Mindfulness balance</a>
                </h3>
              </div>
              <div className="flex justify-between gap-3 lg:gap-0 px-4 md:px-1 lg:px-4 py-3 items-center">
                <p className="text-[17px] text-[#cfa649] font-playfair font-bold">
                  Free
                </p>
                <a href="/" className="text-[17px]  font-bold text-[#16563f]">
                  <WidgetsOutlinedIcon /> Get Enrolled
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full flex flex-col mb-4 md:flex-row">
          <div className="md:w-1/3  w-full  p-4">
            <div className="flex flex-col w-full border-[1px]">
              <div className="w-full ">
                <img
                  src={practice_img_3}
                  alt="practice_img_1"
                  className="object-cover"
                />
              </div>
              <div className="p-6 border-b-[1px]">
                <p className="flex flex-row gap-1 mb-2">
                  <StarBorderOutlinedIcon className="text-[#cfa649]" />
                  <StarBorderOutlinedIcon className="text-[#cfa649]" />
                  <StarBorderOutlinedIcon className="text-[#cfa649]" />
                  <StarBorderOutlinedIcon className="text-[#cfa649]" />
                  <StarBorderOutlinedIcon className="text-[#cfa649]" />
                </p>
                <h3 className="text-2xl font-playfair text-[#17543e] font-medium">
                  <a href="inhale-namaste-mudra-bandha">
                    {" "}
                    Breath of fire inhale
                  </a>
                </h3>
              </div>
              <div className="flex justify-between gap-3 lg:gap-0 px-4 md:px-1 lg:px-4 py-3 items-center">
                <p className="text-[17px] text-[#cfa649] font-playfair font-bold">
                  Free
                </p>
                <a href="/" className="text-[17px]  font-bold text-[#16563f]">
                  <WidgetsOutlinedIcon /> Get Enrolled
                </a>
              </div>
            </div>
          </div>
          <div className="md:w-1/3  w-full   p-4">
            <div className="flex flex-col w-full border-[1px]">
              <div className="w-full ">
                <img
                  src={practice_img_6}
                  alt="practice_img_1"
                  className="object-cover"
                />
              </div>
              <div className="p-6 border-b-[1px]">
                <p className="flex flex-row gap-1 mb-2">
                  <StarBorderOutlinedIcon className="text-[#cfa649]" />
                  <StarBorderOutlinedIcon className="text-[#cfa649]" />
                  <StarBorderOutlinedIcon className="text-[#cfa649]" />
                  <StarBorderOutlinedIcon className="text-[#cfa649]" />
                  <StarBorderOutlinedIcon className="text-[#cfa649]" />
                </p>
                <h3 className="text-2xl font-playfair text-[#17543e] font-medium">
                  <a href="inhale-namaste-mudra-bandha">
                    {" "}
                    Breath of fire inhale
                  </a>
                </h3>
              </div>
              <div className="flex justify-between gap-3 lg:gap-0 px-4 md:px-1 lg:px-4 py-3 items-center">
                <p className="text-[17px] text-[#cfa649] font-playfair font-bold">
                  Free
                </p>
                <a href="/" className="text-[17px]  font-bold text-[#16563f]">
                  <WidgetsOutlinedIcon /> Get Enrolled
                </a>
              </div>
            </div>
          </div>
          <div className="md:w-1/3  w-full  p-4">
            <div className="flex flex-col w-full border-[1px]">
              <div className="w-full">
                <img
                  src={practice_img_2}
                  alt="practice_img_1"
                  className="object-cover"
                />
              </div>
              <div className="p-6 border-b-[1px]">
                <p className="flex flex-row gap-1 mb-2">
                  <StarBorderOutlinedIcon className="text-[#cfa649]" />
                  <StarBorderOutlinedIcon className="text-[#cfa649]" />
                  <StarBorderOutlinedIcon className="text-[#cfa649]" />
                  <StarBorderOutlinedIcon className="text-[#cfa649]" />
                  <StarBorderOutlinedIcon className="text-[#cfa649]" />
                </p>
                <h3 className="text-2xl font-playfair text-[#17543e] font-medium">
                  <a href="inhale-namaste-mudra-bandha"> Mindfulness balance</a>
                </h3>
              </div>
              <div className="flex justify-between gap-3 lg:gap-0 px-4 md:px-1 lg:px-4 py-3 items-center">
                <p className="text-[17px] text-[#cfa649] font-playfair font-bold">
                  Free
                </p>
                <a href="/" className="text-[17px]  font-bold text-[#16563f]">
                  <WidgetsOutlinedIcon /> Get Enrolled
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePagePractice;
